import { Box, TextField } from '@mui/material'
import React, { useState } from 'react'

const ReportCommentInput = ({ id, disabled=false, node, handleCommentChange}) => {
  const [value, setValue] = useState(node.comment || "");
  
  return (
    <Box className="d-flex">
      <TextField
        fullWidth
        id={`${id}-comment`}
        label="Comment"
        disabled={disabled}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={(e) => {
          if(e.target.value !== (node.comment || "")){
            handleCommentChange(e.target.value, node, true);
          }
        }
        }
        multiline
        minRows={2}
        maxRows={5}
        variant="outlined"
        size="small"
        dense="true"
        InputLabelProps={{
          shrink: true,
        }}
      />
    </Box>
  )
}

export default ReportCommentInput
